import { getAllAirtableRecords } from "@/utils/apis/airtable-service"
import { useAuthStore } from "@/utils/stores/useAuthStore"
import { useEffect, useState } from "react"

export const useGetAllRecordsFromTable = () => {
    const { auth } = useAuthStore()
    const idToken = auth.idToken

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [data, setData] = useState<any>(null);

    useEffect(() => {
        const fetchItem = async () => {
            if (!idToken) return
            const response = await getAllAirtableRecords(idToken);
            setLoading(false);
            if (response.success) {
                setData(response.data);
            } else {
                setError(response.error);
            }
        };
        fetchItem();
    }, [idToken])

    return { loading, error, data };
}